import React from 'react';
import { EnterOutlined } from '@ant-design/icons';
import { useHotkeys } from 'react-hotkeys-hook';

type Props = {
  onEnter: () => void;
  children: React.ReactNode;
  showIcon?: boolean;
};

const Enterable: React.FC<Props> = ({ children, onEnter, showIcon = true }: Props) => {
  useHotkeys(
    'Enter',
    e => {
      e.stopPropagation();
      e.preventDefault();
      onEnter();
    },
    [onEnter]
  );
  return (
    <>
      <span>{children}</span>
      {showIcon && (
        <EnterOutlined
          style={{
            fontSize: '.9em',
            marginLeft: 3,
            // position: 'absolute',
            // transform: 'translate(0, 35%)',
          }}
        />
      )}
    </>
  );
};

export default Enterable;
